import { render, staticRenderFns } from "./regist_caohejing.vue?vue&type=template&id=3345f3d2&scoped=true&"
import script from "./regist_caohejing.vue?vue&type=script&lang=js&"
export * from "./regist_caohejing.vue?vue&type=script&lang=js&"
import style0 from "./regist_caohejing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./regist_caohejing.vue?vue&type=style&index=1&id=3345f3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345f3d2",
  null
  
)

export default component.exports